import './App.css';
import { appdata, newsBarMessage } from './internalModules';
import UIAppBar from './ui/UIAppBar';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import { Box, Divider, Grid, Typography } from '@mui/material';
import UIWallTypeList from './ui/UIWallTypeList';
import UIScenarioList from './ui/UIScenarioList';
import React, { useEffect } from 'react'
import UIWelcome from './ui/UIWelcome';
import UINameEdit from './ui/UINameEdit';
import InitializeAnalytics from './analytics/analytics';
import UINewsBar from './ui/UINewsBar';



export const theme = createTheme({
  palette: {
    //primary: blueGrey,
    //secondary: cyan,
    primary: {
      main: '#107DAC',
    },
    secondary: {
      main: '#189AD3',
    },
    text: {
      secondary: 'rgba(0,0,0,0.45)'
    }
  },
  shape: {
    borderRadius: 2
  }
})

export default function App() {
  useEffect(()=>{
    if(window.name !== 'feather') {
      sessionStorage.clear()
      window.name = 'feather'
    }
    InitializeAnalytics()
  }, [])

  const addLocalData = () => {
    let itemCount = appdata.wallTypes.size + appdata.members.size + appdata.materials.size + appdata.scenarios.size
    //don't read local data if we have some already
    if (itemCount > 0) {
      return
    }
    console.log('read local storage...')
    appdata.readLocalStorage()
  }

  const updateApp = () => {
    forceUpdate()
    appdata.writeLocalStorage()
  }

  function updateProjectName(newName: string) {
    appdata.projectName = newName
    updateApp()
  }

  const forceUpdate: () => void = React.useState({})[1].bind(null, {})

  addLocalData()
  let itemCount = appdata.wallTypes.size + appdata.members.size + appdata.materials.size + appdata.scenarios.size

  return (
    
    <ThemeProvider theme={theme}>
      <div className='App'>
        <UINewsBar message={newsBarMessage} width={600}/>
        <UIAppBar updateApp={updateApp} hasButtons={itemCount > 0} />
        {itemCount > 0?
        <>
          <Box mt={11}/>
          <div className='project-name' >
            <UINameEdit currentName={appdata.projectName} toolTip='Rename project' updateName={updateProjectName} />
          </div>

          <Divider/>
          <Typography variant='h4' color={'#aaa'} px={5} pt={2}>Assemblies</Typography>
          <div>
            <UIWallTypeList updateApp={updateApp} assemblies={appdata.getWallTypeArray()}/>
          </div>

          <Divider/>
          <Typography variant='h4' color={'#aaa'} px={5} pt={2}>Scenarios</Typography>
          <div>
            <UIScenarioList updateApp={updateApp}/>
          </div>
        </>
        :
        <>
          <UIWelcome updateApp={updateApp}/>
        </>
        }
      </div>
      <div id={'c'}></div>
    </ThemeProvider>
  );
}